<template>
  <div class="h-100 container">
    <part-base ref="DomForm" :form-data.sync="formData" :disabledNick="disabledNick"
               :show-add-btn="!!$route.query.id"
               :pt="parseInt($route.query.pt)"
               :is-pre-executor="parseInt($route.query.isPreExecutor) === 1"
               @saved="saved"
               @goBack="goBack"
               :type="handleType"
               @goNewAdd="goNewAdd"/>
  </div>
</template>

<script>
import PartBase from "./components/PartBase";
import {systemSettingValue} from "@/api/systemSetting";
import {getOrderDetailBase, temporariesList} from "@/api/order";
import {getPukeDetailBase} from "@/api/regulars";
import {replaceArr} from '@/views/adOrder/regular/replaceData'

export default {
  name: "Create",
  components: {PartBase},
  data() {
    return {
      tmpOrders: [],
      formData: {
        rate: null,// 红人分成
        company_id: null,
        customer_name: '', //客户姓名
        customer_nature: '', //客户性质
        customer_name_custom: null,
        customer_id: '', // 客户ID
        sale: '', //销售
        sale_id: '', // 销售ID
        executor: '', // 执行
        executor_id: '', // 执行ID
        brand: '', // 选中的代理品牌
        trade: '', // 行业
        place_of_origin: '', // 行业
        product: '', // 产品
        order_source: '', // 订单来源
        form_of_cooperation: '', // 合作形式
        exec_customer_id: null, // 执行公司id
        exec_customer_name: '', // 执行公司名称
        product_category: '', // 品类
        passenger_order_interval: '', // 客单
        remark_ffc: '',//合作形式备注：全案营销的时候显示
        //红人信息
        artist_name: '', // 红人名称
        artist_id: '', // 红人ID
        artist_ids: [], // 红人ID
        artist_nms: [], // 红人ID
        agent_name: '', // 经纪人
        release_timestamp: '', //发布时间
        created_timestamp: this.gFunc.parseTime(new Date(), '{y}-{m}-{d}'), //下单时间
        platforms: [], // 平台（多选）
        content_forms: [], // 内容形式（多选）
        ad_space_id: 0,//坑位（视频合集坑位ID）
        project_name: null,
        strategy_name: null,
        strategy_id: null,
        planner_name: null,
        planner_id: null,
        medium_name: null,
        medium_id: null,
        //费用信息
        payment_account: 0, // 含税收入
        authorized_price: 0, // 授权价
        micro_task_price: 0, // 微任务价
        micro_task_income: 0, //微任务所得
        weal_price: 0, // 粉丝福利
        invest_flow_fee: 0, // 投流费
        cart_charges: 0, //购物车费用
        cart_commission: 0, //购物车费用
        offline_rebate: 0, //线下结佣
        tax_point: 6, // 税点
        bool_tax: 1, // 是否含税：1(是)，0(否)
        platform_fee: 0, // 微任务平台费
        platform_fee_po: 0, // 代下单平台费
        rebates_handle: 'rebates_rate',
        rebates_amount: 0,//返点金额
        rebates_rate: 0, //返点比例
        exec_price: 0, // 执行价
        other_fee: 0,  // 其他费
        commission_rate: 0, // 佣金比例
        pay_method: '', // 支付方式
        adv_revenue: 0, // 广告收入
        is_trailer: 0,
        is_lb: 0,
        is_quantity: null,//是否保量: Y:是 N:否
        commission_trailer: null,
        commission_lb: null,
        remark: '', //备注
        //其他
        contract_filed: '',
        source_id: null,//冲账订单和复制订单
        order_type: 'regular',//订单类型：regular【普通订单】、strike【冲账订单】
        covenant_id: null,//合同ID
        live_count: null,//直播次数(全案营销主单)
        gq_amount: null,//保量金额(全案营销主单)
        place_order_money: null,// 下单金额 当平台包含”抖音星图“时显示
        cooperative_ori_price: null,// 合作原价
        // 关联询单
        iq_id: null,
        iq_nm: '',
      },
      replaceArr: replaceArr,
      disabledNick: false,
      handleType: null
    }
  },
  computed: {
    isPureLive() {
      const {isPureLive} = this.$route.query
      return isPureLive && isPureLive === 'true'
    }
  },
  methods: {
    async getTmpOrders() {
      const {model} = await temporariesList()
      this.tmpOrders = model || []
    },
    goBack() {
      this.$router.push({name: "ad-order"});
      // this.$router.back()
    },
    goNewAdd() {
      const {href} = this.$router.resolve({
        name: `detailAdOrder`,
        query: {type: "add"}
      });
      window.open(href, "_self");
    },
    editPage(id) {
      const {href} = this.$router.resolve({
        name: 'editAdOrder',
        params: {id: id},
        query: {isPreExecutor: this.$route.query.isPreExecutor, pt: parseInt(this.$route.query.pt)}
      });

      // this.$router.push(href)
      this.$router.replace(href)
    },

    //创建订单
    saved(id) {
      this.editPage(id)
    },
    clearKolInfo(info) {
      // info.artist_name = '' // 红人名称
      // info.artist_id = ''; // 红人ID
      // info.agent_name = ''; // 经纪人
      info.release_timestamp = ''; //发布时间
      info.created_timestamp = this.gFunc.parseTime(new Date(), '{y}-{m}-{d}'); //下单时间
      info.platforms = []; // 平台（多选）
      info.content_forms = []; // 内容形式（多选）
      info.ad_space_id = 0

    },
    clearFeeInfo(info) {
      info.payment_account = 0; // 含税收入
      info.authorized_price = 0; // 授权价
      info.micro_task_price = 0; // 微任务价
      info.micro_task_income = 0; //微任务所得
      info.weal_price = 0; // 粉丝福利
      info.cart_charges = 0; //购物车费用
      info.cart_commission = 0; //购物车费用
      info.offline_rebate = 0; //线下结佣
      info.tax_point = 6; // 税点
      info.bool_tax = 1; // 是否含税：1(是)，0(否)
      info.platform_fee = 0; // 微任务平台费
      info.platform_fee_po = 0; // 代下单平台费
      info.rebates_handle = 'rebates_rate';
      info.rebates_amount = 0;//返点金额
      info.rebates_rate = 0; //返点比例
      info.exec_price = 0; // 执行价
      info.other_fee = 0;  // 其他费
      info.commission_rate = 0; // 佣金比例
      info.pay_method = ''; // 支付方式
      info.adv_revenue = 0; // 广告收入
      info.is_trailer = 0;
      info.is_lb = 0;
      info.commission_trailer = null;
      info.commission_lb = null;
      info.remark = ''; //备注
    },
    // 获取 && 设置  系统设置 税点
    getSettingTaxPoint() {
      systemSettingValue({key: 'tax_point'}).then((res) => {
        if (res.model)
          this.formData.tax_point = res.model
      })
    },
    formatFormData() {
      this.replaceArr.forEach((item) => {
        if (this.formData[item.new]) {
          this.formData[item.old] = this.formData[item.new]
          delete this.formData[item.new]
        }
      })
      let oldArray = ['strategy_name', 'strategy_id', 'planner_name', 'planner_id', 'medium_name', 'medium_id']
      oldArray.forEach((item) => {
        if (!this.formData[item]) {
          this.formData[item] = null
        }
      })
    },
  },
  mounted() {

  },
  async created() {
    this.getSettingTaxPoint()//获取税点配置
    let type = this.$route.query && this.$route.query.type

    // 合作形式
    if (this.isPureLive) {
      this.formData.form_of_cooperation = '纯直播'
    }

    this.handleType = type
    //暂存订单数据读取
    if (type === 'tmp') {
      await this.getTmpOrders()
      let tempIndex = this.$route.query && this.$route.query.tmpIndex
      if (this.tmpOrders[tempIndex]) {
        this.formData = this.tmpOrders[tempIndex]
      }
    }

    //复制、冲账订单的来源订单ID（数据获取）
    let source_id = this.$route.query && this.$route.query.source_id
    if (source_id) {
      let fromType = this.$route.query && this.$route.query.from
      let info = {}
      if (fromType === 'puke') {
        info = await getPukeDetailBase({id: source_id}).then((res) => {
          return res.model.info;
        })
        info.place_order_money = info.place_order_money || null
      } else {
        info = await getOrderDetailBase({id: source_id}).then((res) => {
          return res.model.info;
        })
        if (info.artist_id && info.is_mark) {
          this.disabledNick = true
        }
      }


      // info.source_id = source_id
      //[复制]订单不记录来源订单ID，[冲账]记录来源ID
      if (type === 'reverse') {
        //冲账的含税收入未负数
        info.source_id = source_id
        info.payment_account = -1 * info.payment_account
        info.place_order_money = -1 * info.place_order_money // 下单金额
        info.order_type = 'strike'
      } else if (type === 'child') {
        //全案营销订单
        delete info.source_id
        info.order_type = 'regular'
        //主订单添加子订单，则使用来源订单ID；若通过子1订单添加主订单子2订单，则使用主订单的ID，即子1订单的pid为子2订单的pid
        if (info.pid === 0)
          info.pid = source_id
        //清空 红人和费用信息
        this.clearKolInfo(info)
        this.clearFeeInfo(info)

      } else {
        delete info.source_id
        info.order_type = 'regular'
      }

      delete info.id
      delete info.order_no
      delete info.created_at
      delete info.updated_at
      delete info.pay_status
      delete info.invoice_status
      delete info.bool_exec
      delete info.contract_filed
      delete info.bool_undo
      delete info.creator
      // delete info.rate
      delete info.company_income
      delete info.artist_income

      this.formData = info
      if (this.formData.project_type && this.formData.project_type === 3) {
        //这里是普客打包订单
        this.formatFormData()
      }


    }

    this.$nextTick(() => {
      this.$refs.DomForm.setData()
    })
  }
}
</script>

<style scoped>

</style>
